import {
  AnyAction,
  ListenerEffectAPI,
  PayloadAction,
  ThunkDispatch,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { FiltersPayloadModel } from '../../shared/models/filters-payload.model';
import { AppsFilters } from '../models/apps-filters.model';
import { getApps } from '../thunks/get-apps.thunk';

export const AppsFilterListenerEffect = (
  action: AnyAction,
  api: ListenerEffectAPI<
    AppRootState,
    ThunkDispatch<AppRootState, undefined, AnyAction>,
    unknown
  >
): void => {
  const currentAction = action as PayloadAction<
    FiltersPayloadModel<AppsFilters>
  >;
  if (currentAction.payload?.property !== 'nameOrDescription') {
    const { filters } = api.getState().appsFeature.apps;
    api.dispatch(getApps(filters));
  }
};
